import React from 'react';
import { node, string } from 'prop-types';
import Card from './Card';
import './Modal.scss';

const Modal = ({ modalBoxClassName, header, children }) => (
  <div className="modal">
    <div className="overlay">
      <Card className={modalBoxClassName}>
        {header && (
          <Card.Header>
            {header}
          </Card.Header>
        )}
        {children && (
          <Card.Content>
            {children}
          </Card.Content>
        )}
      </Card>
    </div>
  </div>
);

Modal.propTypes = {
  modalBoxClassName: string,
  header: node,
  children: node,
};

Modal.defaultProps = {
  modalBoxClassName: null,
  header: null,
  children: null,
};

export default Modal;
